import { makeHttpRequest } from "@/shared";

export const deleteExpense = async (id) => {
    const response = (
        await makeHttpRequest({
            url: `/expense/${id}`,
            method: "DELETE",
        })
    ).data;

    return response;
};
